<div class="col-xl-10 col-lg-10 col-md-10 order-0 order-md-1">

    <div class="mb-2 retour" style="padding: 5px" (click)="retour()">
        <i data-feather="arrow-left" [size]="20"> </i>
        Retour
    </div>

    <!-- Customer Pills -->
    <div class="nav-align-top">
        <ul class="nav nav-pills flex-column flex-md-row mb-6 row-gap-2">
            <li class="nav-item">
                <a
                        class="nav-link"
                        routerLink="/main/parametre/document/vente"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: true }"
                >
                    <i class="bi bi-database" style="font-size: 20px"></i>
                    Devis
                </a>
            </li>

            <li class="nav-item">
                <a
                        class="nav-link"
                        routerLink="/main/parametre/document/vente/commande-client"
                        routerLinkActive="active"
                >
                    <i data-feather="shopping-cart" [size]="20"></i>Commande Client
                </a>
            </li>

            <li class="nav-item">
                <a
                        class="nav-link"
                        routerLink="/main/parametre/document/vente/bon-livraison"
                        routerLinkActive="active"
                >
                    <i data-feather="truck" [size]="20"></i> Bon de livraison
                </a>
            </li>


            <li class="nav-item">
                <a
                        class="nav-link"
                        routerLink="/main/parametre/document/vente/bon-sortie"
                        routerLinkActive="active"
                >
                    <!-- <i data-feather="file-minus" [size]="20"></i>-->
                    <i class="bi bi-file-earmark-arrow-down" style="font-size: 20px"></i>Bon De Sortie
                </a>
            </li>

            <li class="nav-item">
                <a
                        class="nav-link"
                        routerLink="/main/parametre/document/vente/facture"
                        routerLinkActive="active"
                >
                    <i data-feather="file" [size]="20"></i>Facture
                </a>
            </li>



        </ul>
    </div>

    <div class="row text-nowrap">
        <div class="container">
            <router-outlet></router-outlet>
        </div>


    </div>


</div>
